export enum LuxonFormats {
  FullDate = 'cccc, LLLL d',
  Date = 'cccc, LLLL d, yyyy',
  AtTime = "'at 'h:mm a",
  TimeWithTimeZone = "''h:mm a ZZZZ",
  UserFacingDob = 'LL/dd/yyyy',
  ServerDate = 'yyyy-LL-dd',
}
